import {Directive, HostBinding} from '@angular/core';

let NEXT_ID = 0;
@Directive({
  selector: "span[valgFormHint]",
})
export class FormHintDirective {

  @HostBinding('class')
  elementClass = 'valg-form-hint';

  @HostBinding('id')
  id = `valg-form-hint-${NEXT_ID++}`;

}
